import { stripIndent } from 'common-tags';
import { references } from '../../data/references'

const placeholderImage = 'https://storedesign.aesop.com/api/wp-content/uploads/2017/11/Large-JPG-Aesop-AU-Store-QV-05.jpg';

export const data = {
    title: 'Lighting',
    date: '2.06.18',
    blocks: [
        {
            acf_fc_layout: 'text',
            heading: null,
            content: stripIndent`
                Light is an essential tool in the shaping of ambience and mood in the retail environment. For this reason lighting should be given the same attention to detail as all finishes, materials and props used in the architectural design.

                Whilst our aesthetic preference is for soft and warmly lit spaces, there must be enough well-considered lighting configured into the design to make our stores readily visible and to work across all seasons and after-hours as required.
                
                The following guiding principles will assist the designer to develop a holistic and integrated lighting solution for Aesop.
            `
        },
        {
            acf_fc_layout: 'image',
            url: placeholderImage,
            caption: 'image caption'
        },
        {
            acf_fc_layout: 'text',
            heading: 'Lighting hierarchy',
            content: stripIndent`
                Lighting hierarchy is the prioritising of lighting layers to define which surfaces, objects, or areas should be brightest, which should be secondary, and which should be tertiary. The lighting hierarchy should support and enhance the overall design of the space.
                
                The Aesop layers of lighting in order of hierarchy are:
                <ul>
                    <li>Accent lighting (merchandise, point of sale planes and treatment areas)</li>
                    <li>Ambient lighting (fill light, if required)</li>
                    <li>Feature lighting (decorative fixtures and architectural highlighting)</li>
                </ul>
            `
        },
        {
            acf_fc_layout: 'image-reference',
            ...references[0]
        },
        {
            acf_fc_layout: 'image-reference-slideshow',
            images: [
                {
                    ...references[0],
                    imageOverride: placeholderImage,
                    caption: 'override',
                    tags: [
                        {
                            name: 'override',
                            slug: 'override'
                        },
                    ]
                },
                {
                    ...references[0],
                    imageOverride: placeholderImage,
                }
            ]
        },
        {
            acf_fc_layout: 'image-reference-thumbnails',
            images: [
                {
                    ...references[0],
                    imageOverride: placeholderImage,
                },
                {
                    ...references[0],
                    imageOverride: placeholderImage,
                },
                {
                    ...references[0],
                    imageOverride: placeholderImage,
                },
                {
                    ...references[0],
                    imageOverride: placeholderImage,
                },
                {
                    ...references[0],
                    imageOverride: placeholderImage,
                },
                {
                    ...references[0],
                    imageOverride: placeholderImage,
                },
            ]
        },
        {
            acf_fc_layout: 'notes',
            heading: 'Colour Appearance, Temperature ',
            content: stripIndent`
                Lighting hierarchy is the prioritising of lighting layers to define which surfaces, objects, or areas should be brightest, which should be secondary, and which should be tertiary. The lighting hierarchy should support and enhance the overall design of the space.
            `
        },
        {
            layout: 'notes',
            content: stripIndent`
                Joshua Jelly-Schapiro is an American geographer and writer. He is the author of Island People: The Caribbean and the World, out now in paperback, and the co-editor, with the writer Rebecca Solnit, of Nonstop Metropolis: A New York City Atlas. 
            `
        },
    ],
    tags: [
        {
            name: 'Lighting',
            slug: 'lighting'
        },
        {
            name: 'Colour',
            slug: 'colour'
        },
    ],
    relatedPages: [
        {
            section: 'Store Design',
            title: 'Design Thinking',
            slug: 'design-thinking'
        },
        {
            section: 'Store Design',
            title: 'Design Components',
            slug: 'design-components'
        },
        {
            section: 'Store Design',
            title: 'Customer Experience',
            slug: 'customer-experience'
        },
    ],
    attachedPages: [
        {
            title: 'Acoustics',
            slug: 'acoustics'
        },
        {
            title: 'Design Components',
            slug: 'design-components'
        },
    ],
    downloads: [
        {
            title: 'Lighting Specifications',
            size: '2MB',
            url: ''
        },
        {
            title: 'Lighting Specifications',
            size: '2MB',
            url: ''
        },
        {
            title: 'Lighting Specifications',
            size: '2MB',
            url: ''
        },
        {
            title: 'Lighting Specifications',
            size: '2MB',
            url: ''
        },
        {
            title: 'Lighting Specifications',
            size: '2MB',
            url: ''
        },
        {
            title: 'Lighting Specifications',
            size: '2MB',
            url: ''
        },
    ]
}



// WEBPACK FOOTER //
// ./client/modules/Chapters/data.js